"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Adornment = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _FlexAdornment = require("./FlexAdornment");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.node
} : {};

var Adornment = function Adornment(props) {
  if (!props.children) {
    return null;
  }

  if (props.children.length === 0) {
    return null;
  }

  return (0, _core.jsx)(_FlexAdornment.FlexAdornment, props);
};

exports.Adornment = Adornment;
process.env.NODE_ENV !== "production" ? Adornment.propTypes = propTypes : void 0;